// 响应式
function setFont() {
  const html = document.documentElement;
  const designFontSize = 100; // 设计稿基准字体大小
  const breakpoint = 752; // 断点，区分手机端和桌面端
  const maxWindowWidth = 2580; // 最大窗口宽度限制
  const designWidths = {
    desktop: 1920, // 桌面端设计稿宽度
    mobile: 750, // 手机端设计稿宽度
  };
  const calculateFontSize = () => {
    let winWidth = html.getBoundingClientRect().width;
    // 限制窗口宽度不超过 maxWindowWidth
    winWidth = Math.min(winWidth, maxWindowWidth);

    const designWidth =
      winWidth >= breakpoint ? designWidths.desktop : designWidths.mobile;
    let fontSize = (winWidth / designWidth) * designFontSize;

    // 添加最大字体限制（建议值：对于1920设计稿，100px基准时，最大约120-150px）
    const maxFontSize = 100; // 最大字体大小（px）
    fontSize = Math.min(fontSize, maxFontSize);

    html.style.fontSize = `${fontSize}px`;
  };
  calculateFontSize();
  window.addEventListener("resize", calculateFontSize);
  return this;
}
setFont();